export const API_BASE_URL = 'https://capital-bnpl.dev.razorpay.in';
export const API_EDGE_STAGE_BASE = 'capital-bnpl.ext.dev.razorpay.in';
export const API_STAGE_BASE = 'capital-bnpl.ext.dev.razorpay.in';
export const API_PROD_BASE = 'capital-bnpl-ext.razorpay.com';
export const PG_API_PROD_BASE = 'api.razorpay.com';
export const PG_API_STAGE_BASE = 'checkout-service.dev.razorpay.in';
export const PG_API_EDGE_STAGE_BASE = 'api-web.ext.dev.razorpay.in';

export const OTP_REGEX = /^\d{6}$/;
export const CONTACT_REGEX = /^(\+91)?\d{10}$/;
export const PAN_CARD_REGEX = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
export const EMAIL_REGEX = /^[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+$/;
export const PIN_REGEX = /^(\d{4}|\d{6})$/;
export const NUMBER_REGEX = /^\d+$/;

export const INDIAN_CONTACT_COUNTRY_CODE = '+91';

export const API_ENDPOINTS = {
  CUSTOMERS: 'checkout/customers',
  CUSTOMER_STATUS: 'customer/status',
  OTP_VERIFY: 'v2/otp/verify',
  EMAIL_OTP_VERIFY: 'checkout/customers/otp/verify',
  EMI_PLANS: 'customers/payments/emi-plans',
  PAYMENT_FETCH: 'checkout/payments',
  OTP_CREATE: 'otp/create',
  EMAIL_OTP_SEND: 'checkout/customers/otp/send',
  CUSTOMER_REFRESH_ROUTE: 'customer/session/refresh',
  KYC_CHECK: (id: string): string => `checkout/payments/${id}/kyc`,
  E_SIGN: (id: string): string => `checkout/payments/${id}/esign`,
  EMANDATE: (id: string): string => `checkout/payments/${id}/repayment-initiate`,
  PAYMENT_INITIATE: (id: string): string => `checkout/payments/${id}/initiate`,
  PAYMENT_AUTHORIZE: (id: string): string => `checkout/payments/${id}/authorize`,
  KFS_STATEMENT: (id: string): string => `checkout/payments/${id}/kfs`,
  COMPANY_SEARCH: (id: string): string => `checkout/payments/${id}/companies`,
  VERIFY_INCOME: (id: string): string => `checkout/payments/${id}/income-verification`,
  PAYMENT_OTP_RESEND: (id: string): string => `checkout/payments/${id}/otp-resend`,
  EMANDATE_STATUS: (id: string): string => `checkout/payments/${id}/repayment-authorize`,
};

export const CUSTOMER_TOKEN_REFRESH_TIME = 25 * 60 * 1000; // 25 min
export const CUSTOMER_TOKEN_FAILED_TIME = 4 * 60 * 1000; // 4 min
export const CUSTOMER_ACCESS_TOKEN_KEY = 'x-customer-access-token';
export const DATA_HASH_KEY = 'x-data-hash';
export const EMANDATE_POLLING_INTERVAL = 5000; // 5 seconds
export const EMANDATE_POLLING_THRESHOLD = 7 * 60 * 1000; // 7 Minutes
export const EMANDATE_POLLING_WAIT_TIME = 7000; // 7 seconds

export const PG_API_ENDPOINTS = [
  API_ENDPOINTS.OTP_CREATE,
  API_ENDPOINTS.OTP_VERIFY,
  API_ENDPOINTS.CUSTOMER_REFRESH_ROUTE,
];

export const CUSTOMER_EDGE_APIS = [API_ENDPOINTS.CUSTOMERS];

export const SELFIE_KYC_ERRORS = {
  KYC_FAILED: 'KYC_FAILED',
  MAX_RETRY_LIMIT_REACHED: 'MAX_RETRY_LIMIT_REACHED',
} as const;

export const MAX_SELFIE_KYC_RETRIES = 3;

export const LENDER_MAPPING = {
  cashe: 'CASHe',
} as const;

export const LENDER_STATUS_MAPPING = {
  PENDING: 'pending',
  COMPLETE: 'complete',
  NA: 'na',
};

export const PAN_RETRY_ERROR = 'PGCE000044';

export const USER_TYPE = {
  LOGGED_IN: 'logged_in',
  NON_LOGGED_IN: 'non_logged_in',
};

export const ESIGN_SUCCESS = 2500;

export const DEFAULT_RZP_KEY = 'rzp_live_ILgsfZCZoFIKMb';
export const DEFAULT_RZP_STAGE_KEY = 'rzp_test_WDbjEgaCEwT52U';

export const ENV_MAP = {
  PRODUCTION: 'production',
};
